import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import AuthService from './AuthService';
import LoginForm from './components/LoginForm';
import qs from 'qs';

class Login extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.state = {
      userAuthenticated: this.Auth.userAuthenticated(),
      user: {
        email: null,
        password: null
      },
      error: null,
      isGroupLogin: false,
      checkSso: true,
      isFsid: true
    };
    this.changeUser = this.changeUser.bind(this);
    this.hasError = this.hasError.bind(this);
    this.processForm = this.processForm.bind(this);
    this.checkSso = this.checkSso.bind(this);
    this.hasHelperText = this.hasHelperText.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.formError = this.formError.bind(this);
    this.checkLogin = this.checkLogin.bind(this);
  }

  changeUser(event) {
    const field = event.target.name;
    const user = this.state.user;
    user[field] = event.target.value.trim();
    this.setState({
      user
    });

    if (this.state.error) {
      this.setState(() => ({
        error: null
      }));
    }
  }

  checkLogin(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  hasHelperText() {
    if (this.validateEmail()) {
      return 'Please enter a valid email.';
    }
  }

  hasError() {
    if (this.validateEmail() || this.state.error) {
      return true;
    }
  }

  validateEmail() {
    if (this.state.user.email) {
      var isValidEmail = this.state.user.email.match(
        /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
      );
      if (isValidEmail) {
        return false;
      } else {
        return true;
      }
    }
  }

  formError(response) {
    this.setState(() => ({
      error: 'Email or password is incorrect.'
    }));
  }

  processForm(event) {
    event.preventDefault();
    const email = this.state.user.email;
    const password = this.state.user.password;
    if (email && password && !this.validateEmail()) {
      this.Auth.authenticateUser(email, password).then(response => {
        if (response && response.Token) {
          this.setState(() => ({
            userAuthenticated: true
          }));
        } else {
          this.formError(response);
        }
      });
    }
  }

  checkSso(event) {
    event.preventDefault();
    const email = this.state.user.email;
    if (email && !this.validateEmail()) {
      this.Auth.checkSso(email)
        .then(response => {
          if (response && response.isFsid) {
            this.setState(() => ({
              isFsid: true
            }));
            window.location.assign(process.env.REACT_APP_FSID_LOGIN_URL);
          } else {
            this.setState(() => ({
              isFsid: false,
              checkSso: false
            }));
          }
        })
        .catch(err => {
          console.log('error checking SSO', err);
        });
    }
  }

  initializePendo() {
    const authenticatedUser = this.Auth.getUser();
    console.log('authenticatedUser', authenticatedUser);

    // Call this whenever information about your visitors becomes available
    // Please use Strings, Numbers, or Bools for value types.
    // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
    return window.pendo.initialize({
      visitor: {
        id: authenticatedUser.id, // Required if user is logged in
        email: authenticatedUser.email,
        full_name: authenticatedUser.name, //jshint ignore:line
        admin: authenticatedUser.admin,
        inPersonSigning: authenticatedUser.enableInPersonSigning
        // role:         // Optional
        // You can add any additional visitor level key-values here,
        // as long as it's not one of the above reserved names.
      },
      account: {
        id: authenticatedUser.groupData.id, // Highly recommended
        name: authenticatedUser.groupData.name,
        planLevel: authenticatedUser.groupData.billing.plan,
        userCount: authenticatedUser.groupData.userCount
        // planPrice:    // Optional
        // creationDate: // Optional
        // You can add any additional account level key-values here,
        // as long as it's not one of the above reserved names.
      }
    });
  }

  render() {
    const { documents, keypad } = {
      documents: { pathname: '/documents' },
      keypad: { pathname: '/keypad' }
    };
    const { userAuthenticated, error } = this.state;

    if (userAuthenticated) {
      this.initializePendo();

      if (!localStorage.userGroup || localStorage.userGroup === false) {
        return <Redirect to={documents} />;
      } else {
        return <Redirect to={keypad} />;
      }
    } else {
      const code = qs.parse(this.props.location.search, {
        ignoreQueryPrefix: true
      }).code;
      if (code && error == null) {
        this.Auth.exchangeToken(code).then(response => {
          if (response && response.user.sessionId) {
            this.setState(() => ({
              userAuthenticated: true,
              isFsid: true
            }));
          } else {
            this.setState(() => ({
              error: true,
              isFsid: false
            }));
          }
        });
      } else {
        window.location.assign(process.env.REACT_APP_FSID_LOGIN_URL);
      }
    }

    return (
      <div>
        <LoginForm
          onChange={this.changeUser}
          user={this.state.user}
          hasError={this.hasError()}
          hasHelperText={this.hasHelperText()}
          onSubmit={this.processForm}
          validateEmail={this.validateEmail()}
          groupLogin={this.checkLogin}
          isGroupLogin={this.state.isGroupLogin}
          formError={this.state.error}
          isFsid={this.state.isFsid}
          checkSso={this.state.checkSso}
          onClick={this.checkSso}
        />
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/LoginPage.js